import { Component, Input, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-actions-menu',
  templateUrl: './actions-menu.component.html',
  styleUrls: ['./actions-menu.component.scss']
})
export class ActionsMenuComponent {
  @Input() actionsButton!: TemplateRef<any>; // Reference to the large actions template
  @Input() row: any; // Data context
  @Input() enableAccessibility: boolean = false; // Flag to enable accessibility features
  @Input() rowIndex?: number; // Row index for aria-labels
  @Input() currentPage?: number; // Current page for aria-labels
  @Input() pageSize?: number; // Page size for aria-labels
  @Input() popoverClass: string = 'popover-body'; // Optional custom popover class for styling
  @Input() isCollapsed?: boolean; // Control visibility independently (falls back to commonService.is_small_screen if not provided)
  @ViewChild('actionBox', { static: true }) actionBox!: TemplateRef<any>; // Expose actionBox as a TemplateRef
  @ViewChild('menuButton') menuButton!: ElementRef<HTMLButtonElement>;

  private trapFocusListener: ((e: KeyboardEvent) => void) | null = null;
  private popoverContainer: HTMLElement | null = null;

  constructor(public commonService:CommonService){}

  onPopoverShown(): void {
    if (this.enableAccessibility) {
      setTimeout(() => {
        const container = document.querySelector('.popup-actions') as HTMLElement;
        if (!container) return;

        const items = Array.from(container.querySelectorAll('.popup-action-item, .action-button')) as HTMLElement[];
        if (items.length === 0) return;

        // Store container reference for cleanup
        this.popoverContainer = container;

        // Add focus trap that includes the menu button
        this.trapFocusListener = (e: KeyboardEvent) => {
          if (e.key !== 'Tab') return;

          const activeElement = document.activeElement as HTMLElement;
          const isOnMenuButton = activeElement === this.menuButton.nativeElement;

          if (!e.shiftKey) {
            // Tab forward
            if (isOnMenuButton) {
              e.preventDefault();
              items[0].focus(); // From menu button to first item
            } else {
              const focusedIndex = items.findIndex(item => item === activeElement);
              if (focusedIndex === items.length - 1) {
                e.preventDefault();
                this.menuButton.nativeElement.focus(); // From last item back to menu button
              }
            }
          } else if (isOnMenuButton) {
            // Shift+Tab backward
            e.preventDefault();
            items[items.length - 1].focus(); // From menu button to last item
          } else {
            const focusedIndex = items.findIndex(item => item === activeElement);
            if (focusedIndex === 0) {
              e.preventDefault();
              this.menuButton.nativeElement.focus(); // From first item back to menu button
            }
          }
        };

        // Add listener to both menu button and container
        this.menuButton.nativeElement.addEventListener('keydown', this.trapFocusListener);
        container.addEventListener('keydown', this.trapFocusListener);
      }, 0);
    }
  }

  onPopoverHidden(): void {
    if (this.enableAccessibility) {
      // Remove event listeners to prevent focus trap when popover is closed
      if (this.trapFocusListener) {
        if (this.menuButton) {
          this.menuButton.nativeElement.removeEventListener('keydown', this.trapFocusListener);
        }
        if (this.popoverContainer) {
          this.popoverContainer.removeEventListener('keydown', this.trapFocusListener);
        }
        this.trapFocusListener = null;
        this.popoverContainer = null;
      }

      // Restore focus to menu button
      if (this.menuButton) {
        setTimeout(() => {
          this.menuButton.nativeElement.focus();
        }, 0);
      }
    }
  }
}
